import Button from './Button';
import ButtonGroup from './ButtonGroup';

Button.Group = ButtonGroup;

export default Button;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./components/Button/index.ts